import React, { useState } from "react";
import styles from "./style.module.css";

const CTAButton = ({
  children,
  onClick,
  disabled = false,
  fullWidth = false,
  fontSize = "15px",
  type = "button",
  ...rest
}) => {
  const [isPressed, setIsPressed] = useState(false);

  return (
    <button
      type={type}
      className={`${styles['cta-btn']} ${isPressed ? styles['cta-btn--pressed'] : ''} ${fullWidth ? styles['cta-btn--full'] : ''}`}
      onClick={onClick}
      style={{ fontSize }}
      disabled={disabled}
      onMouseDown={() => !disabled && setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onMouseLeave={() => setIsPressed(false)}
      {...rest}
    >
      {children}
    </button>
  );
};

export default CTAButton;
